import React, { useEffect, useState } from 'react';
import styles from './ModalEditDoc.module.scss';
import { ModalComponent } from 'new/routes/RouterManager';
import DocEditor from 'js/components/elements/editors/DocEditor';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';

interface ModalEditDocProps {
  data: any;
  doc: string;
  onUpdate: (id: number, content: string) => Action;
  loadingChecks: string[];
}

export const ModalEditDoc: ModalComponent = (props: ModalEditDocProps & ModalOutProps) => {
  const { data, doc, onUpdate, loadingChecks, setModalActions, setLoading } = props;
  const [content, setContent] = useState(doc);
  const dispatch = useDispatch();
  const loading = useIsLoading(...(loadingChecks || []));

  const onContentChange = (value) => {
    setContent(value);
  };

  const onSave = () => {
    dispatch(onUpdate(data.id, content));
  };

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Save',
        onClick: onSave,
        disabled: content === doc,
      },
    });
  }, [content]);

  return (
    <div className={styles.modalEditor}>
      <DocEditor
        data={data}
        doc={doc}
        isLoading={false}
        defaultEdit
        hideActions
        onDocContentChange={onContentChange}
      />
    </div>
  );
};

ModalEditDoc.modalConfig = {
  name: 'EditDoc',
  title: 'Edit information',
};
